<header class="page-header">
  <div>
    <h1>Alert scadute</h1>
    <p>Manutenzioni oltre la scadenza prevista dal piano</p>
  </div>
  <button type="button" class="primary" (click)="runNow()">Esegui controllo ora</button>
</header>

@if (message()) {
  <p class="flash">{{ message() }}</p>
}

@if (alerts().length === 0) {
  <p class="empty">Nessuna manutenzione scaduta segnalata.</p>
} @else {
  <ul class="alert-list">
    @for (a of alerts(); track a.id) {
      <li>
        <div>
          <strong>{{ a.machine_name }} — {{ a.task_title }}</strong>
          <p>{{ a.message }}</p>
        </div>
        <div class="meta">
          <time>{{ a.created_at | date: 'short' }}</time>
          <span>{{ a.email_sent ? 'Email inviata' : 'Solo in-app' }}</span>
        </div>
      </li>
    }
  </ul>
}
